import React from 'react';
import { CheckCircle } from 'lucide-react';
import Modal from './Modal';
import styles from './ThankYouModal.module.css';

/**
 * Thank you modal — shown after successful contact form submission.
 */
const ThankYouModal = ({ isOpen, onClose }) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={null}
            showCloseButton={true}
            size="sm"
            closeOnOverlay={false}
        >
            <div className={styles.content}>
                <div className={styles.iconWrap}>
                    <CheckCircle className={styles.icon} size={56} strokeWidth={1.5} aria-hidden />
                </div>
                <span className={`sticker-badge ${styles.badge}`}>Sent</span>
                <h3 className={styles.title}>Thank you!</h3>
                <p className={styles.message}>
                    Your message has been sent successfully. We&apos;ll get back to you soon.
                </p>
                <button type="button" className={styles.closeBtn} onClick={onClose}>
                    Close
                </button>
            </div>
        </Modal>
    );
};

export default ThankYouModal;
